import React, { useState } from "react";
import TrainingData from "./trainings.json";
import ImagePopup from "../../imageComponents/image-popup";
import ScrollToTopOnMount from "../../scrollComponents/ScrollToTopOnRoute";

const Training = () => {
  const [popupImage, setPopupImage] = useState(null);

  return (
    <div className="px-6 py-12 relative">
      <ScrollToTopOnMount />

      {/* Section Heading */}
      <h2 className="text-3xl md:text-4xl font-[Lora] font-bold text-[#2c7b2f] text-center mb-10">
        Our Training Programmes
      </h2>

      {/* Trainings Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
        {TrainingData.map((training, idx) => (
          <div
            key={idx}
            className="bg-white rounded-xl shadow-lg overflow-hidden transform hover:scale-105 hover:shadow-2xl transition duration-300 flex flex-col"
          >
            {/* Image */}
            <div
              className="w-full aspect-[16/9] overflow-hidden cursor-pointer"
              onClick={() => setPopupImage(training.imagePath)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) =>
                e.key === "Enter" && setPopupImage(training.imagePath)
              }
            >
              <img
                src={training.imagePath}
                alt={training.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Content */}
            <div className="p-6 flex flex-col flex-grow">
              <h3 className="font-[Lora] font-bold text-[#2c7b2f] text-xl text-center mb-4">
                {training.title}
              </h3>
              <p className="text-gray-700 text-base mb-4">{training.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Image Popup Modal */}
      <ImagePopup
        imageSrc={popupImage}
        altText="Training Image"
        onClose={() => setPopupImage(null)}
      />
    </div>
  );
};

export default Training;
